module.exports = __webpack_public_path__ + "static/img/glove_emeraude.8d8e720.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/colors/women/glove_emeraude.png
// module id = NDba
// module chunks = 0